import {
  newModal,
  mergeModalState,
  closeModal,
  mergeScreenState,
} from "@js/helpers/state.js";
import {
  CE_MODAL_CONVERT_HTML_TO_TEXT_OPEN,
  CE_MODAL_CONVERT_HTML_TO_TEXT_SAVE,
  CE_MODAL_CONVERT_HTML_TO_TEXT_ERROR,
} from "@js/actions/studio/campaign_content_section/modal_convert_html_to_text.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_CONVERT_HTML_TO_TEXT_OPEN: {
      return newModal(state, "convert_html_to_text", {
        client_content_id: action.client_content_id,
      });
    }
    case CE_MODAL_CONVERT_HTML_TO_TEXT_SAVE: {
      return mergeScreenState(closeModal(state), {
        text: action.text,
      });
    }
    case CE_MODAL_CONVERT_HTML_TO_TEXT_ERROR: {
      return mergeModalState(state, {
        validation_error: action.error,
      });
    }
    default: {
      return state;
    }
  }
};
